import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/ui/table";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { Footer } from "../components/Footer";
import { CompactHeader } from "../components/CompactHeader";
import * as Constants from "../../constants";
import BackLoader from "../../components/backloader";

export default function RetiredElevatedDeceasedJudges() {
  const [searchParams] = useSearchParams();
  // keep searchParams referenced so linter won't complain
  const q = searchParams.get("q") || "";

  const [leadership, setLeadership] = useState([]);
  const [category, setCategory] = useState("Retired Elevated Deceased Judges");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    onLoadTeam();
  }, []);
  const onLoadTeam = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/cms/team/${category}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setLeadership(data.items);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const [textSize] = useState("normal");
  const getFontSizeClass = () =>
    textSize === "large"
      ? "text-lg"
      : textSize === "small"
      ? "text-sm"
      : "text-base";

  const judges = [
    {
      sno: "1",
      name: "Hon. Justice Samuel D. Adebiyi",
      status: "Retired",
      timeline: "Oct 12, 1986 - Oct 14, 1973",
    },
    {
      sno: "2",
      name: "Hon Justice  Isiaka I Oluwa",
      status: "Retired",
      timeline: "Jun 01, 1974 - Jun 17, 1983",
    },
    {
      sno: "3",
      name: "Hon Justice Yaya A Jinadu",
      status: "Deceased",
      timeline: "Jun 01, 1974 - Oct 22, 1984",
    },
    {
      sno: "4",
      name: "Hon Justice Wahid A Oshodi",
      status: "Retired",
      timeline: "Mar 06, 1978 - Jan 14, 1992",
    },
    {
      sno: "5",
      name: "Hon. Justice Ishola A. Olorunimbe",
      status: "Retired",
      timeline: "Oct 26, 1984 - Mar 24, 1988",
    },
    {
      sno: "6",
      name: "Hon Justice Samuel O Ilori",
      status: "Retired",
      timeline: "Sep 01, 1980 - Jan 05, 1999",
    },
    {
      sno: "7",
      name: "Hon. Justice Sikiru O.Adagun",
      status: "Retired",
      timeline: "Nov 11, 1980 - May 02, 1999",
    },
    {
      sno: "8",
      name: "Hon. Justice Alpheus O. Silva",
      status: "Retired",
      timeline: "Oct 26, 1984 - Oct 07, 1999",
    },
    {
      sno: "9",
      name: "Hon. Justice Musiliu A, Opeagbe",
      status: "Retired",
      timeline: "Nov 18, 1986 - Mar 31, 2000",
    },
    {
      sno: "10",
      name: "Hon. Justice Akinkunmi O. Holloway",
      status: "Retired",
      timeline: "Oct 31, 1989 - Nov 02, 2000",
    },
    {
      sno: "11",
      name: "Hon. Justice Abd.Rahman A. Sahid",
      status: "Retired",
      timeline: "Mar 03, 1986 - Mar 07, 2001",
    },
    {
      sno: "12",
      name: "Hon. Justice Monisola A. Fafiade",
      status: "Retired",
      timeline: "Mar 31, 1983 - Apr 09, 2001",
    },
    {
      sno: "13",
      name: "Hon. Justice Christopher O. Segun",
      status: "Retired",
      timeline: "Apr 01, 1983 - May 26, 2001",
    },
    {
      sno: "14",
      name: "Hon. Justice Yushau O. Yusuph",
      status: "Retired",
      timeline: "Jul 19, 1996 - Jul 21, 2001",
    },
    {
      sno: "15",
      name: "Hon. Justice Oluyimisola C. Olufawo",
      status: "Retired",
      timeline: "Feb 18, 1994 - Sep 24, 2001",
    },
    {
      sno: "16",
      name: "Hon. Justice Francis A. Owobiyi",
      status: "Retired",
      timeline: "Oct 31, 1989 - Oct 28, 2001",
    },
    {
      sno: "17",
      name: "Hon. Justice Solomon. O. Hunponu-Wusu",
      status: "Retired",
      timeline: "Feb 11, 1986 - Mar 14, 2002",
    },
    {
      sno: "18",
      name: "Hon. Justice Sekinat A. Adebajo",
      status: "Retired",
      timeline: "Jul 19, 1996 - Sep 29, 2002",
    },
    {
      sno: "19",
      name: "Hon. Justice Folorunsho E. Longe",
      status: "Retired",
      timeline: "Apr 01, 1983 - Apr 19, 2002",
    },
    {
      sno: "20",
      name: "Hon. Justice Moshood A. Olugbani",
      status: "Retired",
      timeline: "Feb 11, 1986 - Aug 22, 2002",
    },
    {
      sno: "21",
      name: "Hon. Justice Ibitola A. Sotiminu",
      status: "Retired",
      timeline: "Feb 11, 1986 - Mar 19, 2004",
    },
    {
      sno: "22",
      name: "Hon. Justice Afolabi A. Adeyinka",
      status: "Retired",
      timeline: "Feb 11, 1982 - Jul 02, 2004",
    },
    {
      sno: "23",
      name: "Hon. Justice Dolapo F. Akinsanya",
      status: "Retired",
      timeline: "Oct 31, 1989 - Feb 24, 2006",
    },
    {
      sno: "24",
      name: "Hon. Justice Abike E. Lufadeju",
      status: "Retired",
      timeline: "Sep 17, 1998 - May 01, 2008",
    },
    {
      sno: "25",
      name: "Hon. Justice Augustine A. Alabi",
      status: "Retired",
      timeline: "Nov 18, 1986 - Aug 08, 2009",
    },
    {
      sno: "26",
      name: "Hon. Justice Sunday O. Ishola",
      status: "Retired",
      timeline: "May 24, 2001 - Jan 17, 2011",
    },
    {
      sno: "27",
      name: "Hon. Justice Benedicta O. Shittabey",
      status: "Retired",
      timeline: "Jul 19, 1986 - Jul 09, 2011",
    },
    {
      sno: "28",
      name: "Hon. Justice Inumidun. E. Akande",
      status: "Retired",
      timeline: "Oct 31, 1989 - Jun 10, 2012",
    },
    {
      sno: "29",
      name: "Hon. Justice Titilola Ojikutu-Oshode",
      status: "Retired",
      timeline: "May 24, 2001 - Jun 12, 2012",
    },
    {
      sno: "30",
      name: "Hon. Justice Olateru-Olagbegi",
      status: "Retired",
      timeline: "May 24, 2001 - Apr 24, 2014",
    },
    {
      sno: "31",
      name: "Hon. Justice Adebisi Kayode-Ogunmekan",
      status: "Retired",
      timeline: "Sep 17, 1998 - Aug 12, 2015",
    },
    {
      sno: "32",
      name: "Hon. Justice Ayotunde A. Phillips",
      status: "Retired",
      timeline: "Feb 18, 1994 - Jul 26, 2014",
    },
    {
      sno: "33",
      name: "Hon. Justice Ebenezer. A. Adebajo",
      status: "Retired",
      timeline: "Jan 29, 2004 - Jul 05, 2014",
    },
    {
      sno: "34",
      name: "Hon. Justice Oluyinka Gbajabiamila",
      status: "Retired",
      timeline: "May 24, 2001 - Nov 30, 2016",
    },
    {
      sno: "35",
      name: "Hon. Justice Deborah O. Oluwayemi",
      status: "Retired",
      timeline: "May 24, 2001 - Mar 31, 2017",
    },
    {
      sno: "36",
      name: "Hon. Justice Olufunmilayo A. Atilade",
      status: "Retired",
      timeline: "Jul 19, 1996 - Sep 24, 2017",
    },
    {
      sno: "37",
      name: "Hon. Justice Yetunde O. Idowu",
      status: "Deceased",
      timeline: "Sep 17, 1998 - May 02, 2019",
    },
    {
      sno: "38",
      name: "Hon. Justice Opeyemi Oke",
      status: "Retired",
      timeline: "Jul 19, 1996 - Jun 10, 2019",
    },
    {
      sno: "39",
      name: "Hon. Justice Folashade J. Bankole-Oki",
      status: "Retired",
      timeline: "May 28, 2013 - Jul 01, 2019",
    },
    {
      sno: "40",
      name: "Hon. Justice Olushola A. Williams",
      status: "Retired",
      timeline: "May 24, 2001 - Jul 18, 2019",
    },
    {
      sno: "41",
      name: "Hon Justice Doris T. Okuwobi",
      status: "Retired",
      timeline: "Sep 17, 1998 - Jan 10, 2020",
    },
    {
      sno: "42",
      name: "Hon. Justice Grace M. Onyeabo",
      status: "Deceased",
      timeline: "May 24, 2001 - May 05, 2021",
    },
    {
      sno: "43",
      name: "Hon. Justice Iyabo O. Kasali",
      status: "Retired",
      timeline: "May 24, 2001 - Jun 02, 2021",
    },
    {
      sno: "44",
      name: "Hon. Justice Samuel B.A. Candide-Johnson",
      status: "Retired",
      timeline: "May 24, 2001 - Jun 27, 2021",
    },
    {
      sno: "45",
      name: "Hon. Justice Owolabi A. Dabiri",
      status: "Retired",
      timeline: "Mar 18, 2008 - Sep 30, 2021",
    },
    {
      sno: "46",
      name: "Hon. Justice Mufutau Olokoba",
      status: "Retired",
      timeline: "May 24, 2001 - Dec 31, 2021",
    },
    {
      sno: "47",
      name: "Hon. Justice Mobolanle Okikiolu-Ighile",
      status: "Retired",
      timeline: "Mar 18, 2008 - Jul 25, 2022",
    },
    {
      sno: "48",
      name: "Hon. Justice O.A.Taiwo",
      status: "Retired",
      timeline: "Jan 29, 2004 - Sep 22, 2022",
    },
    {
      sno: "49",
      name: "Hon. Justice J. Oke-Lawal",
      status: "Retired",
      timeline: "Jan 29, 2004 - Oct 19, 2022",
    },
    {
      sno: "50",
      name: "Hon. Justice S.O Solebo",
      status: "Retired",
      timeline: "Jun 13, 2017 - Nov 28, 2022",
    },
    {
      sno: "51",
      name: "Hon. Justice A.A. Akintoye",
      status: "Retired",
      timeline: "Dec 18, 2014 - Jan 31, 2023",
    },
    {
      sno: "52",
      name: "Hon. Justice T.A.O. Oyekan-Abdullai",
      status: "Retired",
      timeline: "Sep 17, 1998 - Feb 05, 2023",
    },
    {
      sno: "53",
      name: "Hon Justice L.B. Lawal-Akapo",
      status: "Elevated",
      timeline: "Mar 18, 2008 - Jul 09, 2024",
    },
    {
      sno: "54",
      name: "Hon Justice G.A. Safari",
      status: "Deceased",
      timeline: "May 28, 2013 - Apr 13, 2025",
    },
  ];

  const statusBadge = (status) => {
    if (status == null) return;
    const s = status?.toLowerCase();
    if (s.includes("deceased"))
      return <Badge variant="destructive">Deceased</Badge>;
    if (s.includes("elevated"))
      return <Badge variant="outline">Elevated</Badge>;
    return <Badge variant="secondary">Retired</Badge>;
  };

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <CompactHeader />
      <section className="relative py-24 bg-hero-light-image dark:bg-hero-dark">
        <div className="absolute inset-0 bg-black/5 dark:bg-black/30"></div>
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-gray-900 dark:text-white">
              <div>Retired / Elevated / Deceased Judges</div>{" "}
              <small>of the High Court of Lagos State</small>
            </h1>
          </div>
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-8 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
          <Accordion type="single" collapsible defaultValue="item-1">
            <AccordionItem value="item-1">
              <AccordionTrigger className="text-xl font-bold">
                Retired / Elevated / Deceased Judges ({leadership.length})
              </AccordionTrigger>

              <AccordionContent>
                <Card className="mt-6 border-0 shadow-lg">
                  <CardContent className="p-0">
                    <div className="overflow-x-auto">
                      <Table className="min-w-full">
                        <TableHeader>
                          <TableRow>
                            <TableHead>S/No</TableHead>
                            <TableHead>Name of Judge</TableHead>
                            <TableHead>Status</TableHead>
                            <TableHead>Timeline (From - To)</TableHead>
                          </TableRow>
                        </TableHeader>

                        <TableBody>
                          {leadership.map((j, i) => (
                            <TableRow
                              key={i}
                              className="hover:bg-gray-100 dark:hover:bg-slate-700 transition"
                            >
                              <TableCell className="whitespace-nowrap px-4 py-3">
                                {i + 1}
                              </TableCell>
                              <TableCell className="px-4 py-3 font-semibold">
                                {j.fullName}
                              </TableCell>
                              <TableCell className="px-4 py-3">
                                {statusBadge(j.currentStatus)}
                              </TableCell>
                              <TableCell className="px-4 py-3">
                                {j.timeframe}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  </CardContent>
                </Card>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </section>
      <Footer />
      <BackLoader open={loading} />
    </div>
  );
}
